module.exports = __webpack_public_path__ + "img/rank-1.0.00431dca.svg";